import { render } from "./KASModalImport.vue?vue&type=template&id=4f2e9f3c"
import script from "./KASModalImport.vue?vue&type=script&lang=js"
export * from "./KASModalImport.vue?vue&type=script&lang=js"

import "./KASModalImport.vue?vue&type=style&index=0&id=4f2e9f3c&lang=scss"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__